<template>
  <model-form
    :model="hardwareJob"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-gutter-md items-start">
        <q-select
          v-model="hardwareJob.jobName"
          :options="hardwareJob.fieldOptions('jobName')"
          class="col"
          label="Job Name"
          map-options
          emit-value
          :rules="[val => val !== null || 'Field is required']"
          bottom-slots
          autofocus
        />
        <q-select
          v-model="hardwareJob.hardware"
          class="col"
          label="Hardware"
          option-label="name"
          map-options
          :rules="[val => val !== null || 'Field is required']"
          :options="hardwares.data"
          bottom-slots
        />
      </div>
      <div

        class="row q-col-gutter-md items-start"
      >
        <q-input
          v-model.number="hardwareJob.parameters.days_before"
          class="col"
          label="Data From (Days Prior to Include)"
          step="1"
          min="0"
          max="60"
          type="number"
          bottom-slots
          :rules="[val => !!val && (val >= 0 && val <= 60) || 'Must be between 0 and 60']"
        />
        <q-input
          v-model.number="hardwareJob.parameters.days_after"
          class="col"
          label="Data To (Days After to include)"
          step="1"
          min="0"
          max="60"
          type="number"
          bottom-slots
          :rules="[val => !!val && (val >= 0 && val <= 60) || 'Must be between 0 and 60']"
        />
      </div>
      <div class="row q-col-gutter-md items-start">
        <q-input
          v-model="hardwareJob.remoteHost"
          class="col"
          label="Remote Host"
          type="url"
          bottom-slots
          :rules="[val => !!val || 'Field is required']"
        >
          <q-tooltip>
            Address of ftp server e.g. ftp.dlptest.com or 10.0.0.1
          </q-tooltip>
        </q-input>
        <q-input
          v-model="hardwareJob.remoteUser"
          class="col"
          label="Remote User"
          type="text"
          bottom-slots
        >
          <q-tooltip>
            FTP authentication username
          </q-tooltip>
        </q-input>
      </div>
      <div class="row q-gutter-md items-start">
        <q-input
          v-model="hardwareJob.remotePassword"
          class="col"
          label="Remote Password"
          type="text"
          bottom-slots
        >
          <q-tooltip>
            FTP authentication password
          </q-tooltip>
        </q-input>
        <q-input
          v-model="hardwareJob.remoteFilename"
          class="col"
          label="Remote Filename"
          type="text"
          bottom-slots
          :rules="[val => !!val || 'Field is required']"
        >
          <q-tooltip>
            FTP Path and/or name of file
          </q-tooltip>
        </q-input>
        <q-toggle
          v-model="hardwareJob.tlsEnabled"
          :label="`TLS ${hardwareJob.tlsEnabled ? 'Enabled' : 'Disabled'}`"
        />
      </div>
      <div
        v-if="hardwareJob.daysOfMonth === null"
        class="row q-col-gutter-md items-start"
      >
        <q-toggle
          :model-value="hardwareJob.daysOfWeek !== null"
          class="col-6"
          label="Specific Days of Week"
          bottom-slots
          @update:model-value="(value) => value ? (hardwareJob.daysOfWeek = []) : (hardwareJob.daysOfWeek = null) "
        />
        <q-select
          v-model="hardwareJob.daysOfWeek"
          multiple
          use-chips
          class="col-6"
          label="Days of Week"
          :options="DAYS_OF_WEEK_FOR_SELECT"
          map-options
          emit-value
          bottom-slots
          :rules="[val => hardwareJob.daysOfWeek === null || hardwareJob.daysOfWeek.length > 0 || 'Must select at least one day']"
        />
      </div>
      <div
        v-if="hardwareJob.daysOfWeek === null"
        class="row q-col-gutter-md items-start"
      >
        <q-toggle
          :model-value="hardwareJob.daysOfMonth !== null"
          class="col-6"
          label="Specific Days of Month"
          bottom-slots
          @update:model-value="(value) => value ? (hardwareJob.daysOfMonth = []) : (hardwareJob.daysOfMonth = null) "
        />
        <q-select
          v-model="hardwareJob.daysOfMonth"
          multiple
          use-chips
          class="col-6"
          label="Days of Month"
          :options="$_.range(1,29)"
          bottom-slots
          :rules="[val => hardwareJob.daysOfMonth === null || hardwareJob.daysOfMonth.length > 0 || 'Must select at least one day']"
        />
      </div>
      <div
        v-if="hardwareJob.daysOfMonth !== null"
        class="row q-col-gutter-md items-start"
      >
        <q-toggle
          :model-value="hardwareJob.monthsOfYear !== null"
          class="col-6"
          label="Specific Months of the Year"
          bottom-slots
          @update:model-value="(value) => value ? (hardwareJob.monthsOfYear = []) : (hardwareJob.monthsOfYear = null) "
        />
        <q-select
          v-model="hardwareJob.monthsOfYear"
          multiple
          use-chips
          class="col-6"
          label="Months of the Year"
          :options="$_.range(1,13)"
          bottom-slots
          :rules="[val => hardwareJob.monthsOfYear === null || hardwareJob.monthsOfYear.length > 0 || 'Must select at least one day']"
        />
      </div>
      <div
        class="row q-col-gutter-md items-start"
      >
        <q-checkbox
          v-model="hardwareJob.enabled"
          label="Enabled"
          class="col-6"
        />
        <q-select
          v-model="hardwareJob.hourOfDay"
          class="col-6"
          label="Hour of Day"
          :options="$_.range(0, 24)"
          :rules="[val => val !== null || 'Field is required']"
          bottom-slots
        >
          <q-tooltip>
            Hour of day in military time. e.g. 0 is midnight and 12 is noon, and 16 is 4 pm
          </q-tooltip>
        </q-select>
      </div>
      <div
        class="row q-col-gutter-md items-start"
      >
        <q-input
          v-if="hardwareJob.lastErrorMessage"
          v-model="hardwareJob.lastErrorMessage"
          label="Last Error Message"
          readonly
          class="col"
        />
      </div>
    </div>
    <template #actions>
      <q-btn
        v-if="!hardwareJob.isLocal"
        label="Send Now"
        class="col-3"
        :disable="hardwareJob.loading"
        outline
        @click="triggerSend"
      />
    </template>
  </model-form>
</template>
<script>
import { DAYS_OF_WEEK_FOR_SELECT } from 'src/models/hardware/HardwareJob'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'HardwareJobForm',
  components: {
    ModelForm
  },
  created () {
    _.extend(this, { DAYS_OF_WEEK_FOR_SELECT })
  },
  methods: {
    async triggerSend () {
      this.hardwareJob.action = 'send_data'
      const results = await this.hardwareJob.save()
      if (results.errors.length) {
        this.$mh.showErrors(results.errors)
      } else {
        this.$mh.notify('Job has started')
      }
      this.hardwareJob.resetField('action')
    }
  },
  models: {
    hardwareJob: {
      hardware: {
        fields: ['id', 'name']
      }
    },
    hardwares: {
      fields: ['id', 'name']
    }
  }
}

</script>
